import { debug } from '../../../utils';
import { createAjaxEpic } from '../utils';
import { fetch, post } from './actions';
const log = debug('lego:models/Profile/epics');

import { fetchProfileAPI } from 'server/api/Profile/api'
const fetchProfileEpic = createAjaxEpic(fetchProfileAPI)
post.complete = [post.complete]
	.concat((fetch.complete as any)
					.map(fn => (_, profile) => fn(profile))) as any

const postProfileEpic = createAjaxEpic('/api/profile/', post, 'post');

export { fetchProfileEpic, postProfileEpic };



// WEBPACK FOOTER //
// ./src/app/models/Profile/epics.ts